import React from "react";
import styles from "./meter-type-select.module.scss";
import { ConsumerType } from "../../../../model/energy-profile";

interface MeterTypeSelectProps {
	value: ConsumerType | null;
	onChange: (type: ConsumerType) => void;
}

const PrepaidIcon: React.FC = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.999 2C7.58016 2 3.99805 5.58212 3.99805 10.0009C3.99805 12.5861 5.22495 14.885 7.12515 16.3465C7.40216 16.5595 7.69358 16.7549 7.99775 16.9308V17H16.0001V16.9308C16.3043 16.7549 16.5957 16.5595 16.8727 16.3465C18.7729 14.885 19.9998 12.5861 19.9998 10.0009C19.9998 5.58212 16.4177 2 11.999 2Z" fill="var(--app-primary-text)" fillOpacity="0.8" />
		<path d="M7.99805 18.9988V18.5H16.0004V18.9988C16.0004 21.2086 14.2091 23 11.9993 23C9.78944 23 7.99805 21.2086 7.99805 18.9988Z" fill="var(--app-primary-text)" fillOpacity="0.8" />
		<path d="M3.20289 12.8574C3.07482 12.4638 2.65227 12.2483 2.25855 12.376L1.30738 12.6855C0.913493 12.8135 0.698049 13.236 0.825932 13.6299C0.953913 14.0238 1.37638 14.2392 1.77027 14.1113L2.72144 13.8027C3.11538 13.6747 3.33088 13.2514 3.20289 12.8574Z" fill="var(--app-primary-text)" fillOpacity="0.8" />
		<path d="M21.7439 12.376C21.35 12.248 20.9266 12.4635 20.7986 12.8574C20.6707 13.2513 20.8862 13.6747 21.28 13.8027L22.2312 14.1113C22.6251 14.2393 23.0485 14.0238 23.1765 13.6299C23.3045 13.236 23.0889 12.8127 22.6951 12.6846L21.7439 12.376Z" fill="var(--app-primary-text)" fillOpacity="0.8" />
		<path d="M1.69608 5.86615C1.32466 5.78606 0.945913 5.99892 0.825958 6.3681C0.706105 6.73726 0.887582 7.13162 1.23514 7.2851L1.30741 7.31244L2.25858 7.62201C2.6523 7.74968 3.07485 7.53417 3.20292 7.14056C3.32288 6.77134 3.14138 6.37607 2.79374 6.2226L2.72147 6.19525L1.7703 5.88666L1.69608 5.86615Z" fill="var(--app-primary-text)" fillOpacity="0.8" />
		<path d="M23.1765 6.3682C23.0485 5.97431 22.6251 5.75877 22.2312 5.88676L21.28 6.19535C20.8862 6.32334 20.6707 6.7468 20.7986 7.14066C20.9266 7.53461 21.35 7.75011 21.7439 7.62211L22.6951 7.31352C23.0889 7.18544 23.3045 6.76208 23.1765 6.3682Z" fill="var(--app-primary-text)" fillOpacity="0.8" />
	</svg>
);

const PostpaidIcon: React.FC = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.1108 21.8189 14.1793 21.4846 15.1776C21.3539 15.0668 21.1847 15 21 15H12.4546L9.66494 9.65308C9.47334 9.28584 9.02031 9.14346 8.65308 9.33506C8.28584 9.52666 8.14346 9.97969 8.33506 10.3469L10.7628 15H3C2.81526 15 2.64612 15.0668 2.51541 15.1776C2.18111 14.1793 2 13.1108 2 12Z" fill="var(--app-primary-text)" fillOpacity="0.8" />
		<path d="M3.06641 16.5C4.71322 19.7626 8.09488 22 11.9991 22C15.9034 22 19.285 19.7626 20.9318 16.5H3.06641Z" fill="var(--app-primary-text)" fillOpacity="0.8" />
	</svg>
);

export const MeterTypeSelect: React.FC<MeterTypeSelectProps> = ({ value, onChange }) => (
	<section className={styles.card}>
		<header className={styles.cardHeader}>
			<span className={styles.cardLabel}>Select Meter Type</span>
		</header>
		<div className={styles.meterTypeGrid}>
			<button
				type="button"
				className={`${styles.meterTypeTile} ${value === ConsumerType.Prepaid ? styles.meterTypeTileActive : ""}`}
				onClick={() => onChange(ConsumerType.Prepaid)}
				aria-pressed={value === ConsumerType.Prepaid}
			>
				<span className={styles.meterTypeIconWrap}><PrepaidIcon /></span>
				<span className={styles.meterTypeLabel}>Prepaid</span>
			</button>
			<div className={styles.meterTypeDivider} />
			<button
				type="button"
				className={`${styles.meterTypeTile} ${value === ConsumerType.Postpaid ? styles.meterTypeTileActive : ""}`}
				onClick={() => onChange(ConsumerType.Postpaid)}
				aria-pressed={value === ConsumerType.Postpaid}
			>
				<span className={styles.meterTypeIconWrap}><PostpaidIcon /></span>
				<span className={styles.meterTypeLabel}>Postpaid</span>
			</button>
		</div>
	</section>
);
